export { createValidator as default } from 'lib/valida';
export type { Ow } from 'ow';
